import React from "react";
import { VISITOR_STATUS_LABELS } from "../../utils/visitorStatuses";
import { resolveVisitorStatus } from "../../utils/visitorStatus";

const STATUS_CLASS = {
  [VISITOR_STATUS_LABELS.INSIDE]: "visitor-status--inside",
  [VISITOR_STATUS_LABELS.COMPLETED]: "visitor-status--completed",
  [VISITOR_STATUS_LABELS.PENDING_EXIT]: "visitor-status--pending",
};

export default function VisitorStatusBadge({ visitor }) {
  const label = resolveVisitorStatus(visitor);
  const tone = STATUS_CLASS[label] || "visitor-status--pending";

  return (
    <span className={`visitor-status-tag ${tone}`}>{label || "—"}</span>
  );
}
